export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

export const getVerdictColor = (
  verdict?: string
): 'success' | 'error' | 'warning' => {
  switch (verdict?.toLowerCase()) {
    case 'processing':
    case 'processed':
    case 'paid':
    case 'approved':
    case 'partial-approved':
      return 'success';
    case 'rejected':
      return 'error';
    default:
      return 'warning';
  }
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const getVerdictDisplayText = (
  verdict?: string,
  amount?: number
): string => {
  if (!verdict) return 'Pending';

  const capitalizedVerdict =
    verdict.charAt(0).toUpperCase() +
    verdict.slice(1).split('-').join(' ').toLowerCase();
  if (verdict === 'partial-approved' && amount) {
    return `${capitalizedVerdict} (${formatter.format(amount)})`;
  }

  return capitalizedVerdict;
};

export const canUserApproveReject = (userRole?: string): boolean => {
  return userRole !== 'data_reader';
};

export const isVerdictActionable = (bill: any): boolean => {
  return !bill.verdict;
};

export const getVerdictEditOptions = (currentVerdict?: string) => {
  switch (currentVerdict) {
    case 'approved':
      return {
        options: ['reject', 'partial-approved'],
        title: 'Edit Approved Bill',
        description:
          'You can reject this bill or change it to partial approval.',
      };
    case 'partial-approved':
      return {
        options: ['reject', 'approved'],
        title: 'Edit Partially Approved Bill',
        description: 'You can reject this bill or approve it fully.',
      };
    case 'rejected':
      return {
        options: ['approved', 'partial-approved'],
        title: 'Edit Rejected Bill',
        description: 'You can approve this bill fully or partially.',
      };
    default:
      return {
        options: ['approved', 'partial-approved', 'rejected'],
        title: 'Edit Bill Verdict',
        description: 'Choose the new verdict for this bill.',
      };
  }
};

export const validateAmount = (
  value: string,
  maxAmount: number
): { isValid: boolean; error?: string } => {
  if (!value || value.trim() === '') {
    return { isValid: false, error: 'Amount is required' };
  }

  const numValue = parseFloat(value);
  if (isNaN(numValue)) {
    return { isValid: false, error: 'Please enter a valid number' };
  }

  if (numValue < 1) {
    return { isValid: false, error: 'Amount must be at least $1.00' };
  }

  if (numValue > maxAmount) {
    return {
      isValid: false,
      error: `Amount cannot exceed bill amount of ${formatCurrency(maxAmount)}`,
    };
  }

  return { isValid: true };
};
